var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"arrow_wrap",on:{"click":_vm.onClicked}},[_c('span'),_c('span')])}
var staticRenderFns = []

export { render, staticRenderFns }